// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class Prescriber {
    static getAttributeTypeMap() {
        return Prescriber.attributeTypeMap;
    }
}
Prescriber.discriminator = undefined;
Prescriber.additionalProperties = false;
Prescriber.attributeTypeMap = [
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "string"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "Address"
    },
];
//# sourceMappingURL=prescriber.js.map